import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { addClassToBody }  from '../../utils/utils';
import { connect }  from 'react-redux';
import { getAuthToken }  from '../../store/actions';
import { Redirect, withRouter } from 'react-router-dom';
import { Form } from 'react-form';
import sha256 from 'js-sha256';
import TextFields from '../UI/TextFiled';
import CheckboxElement from '../UI/Checkbox';
import illustration from '../../assets/img/illustration.svg';
import { validate } from '../../utils/constants';

class Login extends Component {

    state = {};

    submitted = submittedValues => {
        if (submittedValues.doesRemember) {
            localStorage.setItem('foodna-c-email', submittedValues.email);
            localStorage.setItem('foodna-c-password', submittedValues.password);
        } else {
            localStorage.removeItem('foodna-c-email');
            localStorage.removeItem('foodna-c-password');
        }
        submittedValues.doesRemember = true;
        this.props.getAuthToken(submittedValues);
    };

    render() {
        addClassToBody();

        let authRedirect = null;
        if (this.props.isAuthenticated) {
            authRedirect = <Redirect to={this.props.authRedirectPath}/>
        }

        return (
            <div className="sign-form flex">
                { authRedirect }
                <div className="illustration flex align-center">
                    <img src={ illustration } alt="right illustration"/>
                </div>
                <div className="form">
                    <div className="form-title flex align-center justify-center">
                        <h1 className="uppercase">log in</h1>
                    </div>

                    <Form onSubmit={ this.submitted } >
                        { formApi => (
                            <form onSubmit={formApi.submitForm} id="form5">
                                <div className="inner">

                                    <TextFields defaultValue={ localStorage.getItem('foodna-c-email') }
                                                formApi={formApi} validations={[...validate.$email]}
                                                type="text"
                                                label="Email"
                                                field="email"/>

                                    <TextFields defaultValue={ localStorage.getItem('foodna-c-password') }
                                                formApi={formApi} validations={[...validate.$required]}
                                                type="password"
                                                label="Password"
                                                field="password"/>

                                    <div className="flex align-center justify-between mt-30">
                                        <div className="chekbox full-width">
                                            <CheckboxElement label="Remember Me" field="doesRemember"/>
                                        </div>
                                        {/*<div className="full-width text-right">*/}
                                            {/*<Link className="underline color-primary w-800" to="/forgot">Forgot Password</Link>*/}
                                        {/*</div>*/}
                                    </div>

                                    <div className="text-center mt-90">
                                        <button type="submit" className="btn filled primary min-220">Login</button>
                                    </div>
                                </div>
                            </form>
                        )}
                    </Form>

                </div>
            </div>
        );
    }
}


const mapDispatchToProps = dispatch => {
    return {
        getAuthToken: credentials => dispatch( getAuthToken(credentials) )
    };
};

const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.token !== null,
        authRedirectPath: state.auth.authRedirectPath
    };
};

export default withRouter( connect(mapStateToProps, mapDispatchToProps)( Login ) );



// WEBPACK FOOTER //
// ./src/components/Login/Login.js